import { combineReducers } from 'redux';

import { Actions, ActionTypes } from '../actions';

export const mapErrorToMessage = (error: any) => {
	const code = error && 'code' in error ? error.code : '';
	switch (code.toLowerCase()) {
		case 'usernameexistsexception':
			return 'An account with that email address already exists.';
		case 'invalidparameterexception':
			return 'Please make sure your username and password meet the required criteria.';
		case 'invalidpasswordexception':
			return 'Please make sure your password meets the required criteria.';
		default:
			return 'Please contact support for help creating your account.';
	}
};

export const result = (state = { failed: false, message: '' }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_REGISTRATION_RECEIVE:
			return { failed: false, message: '' };
		case ActionTypes.ADMIN_REGISTRATION_FAILURE:
			return { failed: true, message: mapErrorToMessage(action.payload.error) };
		default:
			return state;
	}
};

export const loading = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_REGISTRATION_REQUEST:
			return true;
		case ActionTypes.ADMIN_REGISTRATION_RECEIVE:
		case ActionTypes.ADMIN_REGISTRATION_FAILURE:
			return false;
		default:
			return state;
	}
};

export interface IAdminSignupPageState {
	result: ReturnType<typeof result>;
	loading: ReturnType<typeof loading>;
}

const adminSignup = combineReducers<IAdminSignupPageState>({
	result,
	loading
});

export default adminSignup;
